import Vue from 'vue'

import App from './App'
import router from './router'
import store from '@/store'
import { CHECK_AUTH } from '@/store/actions.type'

import ApiService from '@/common/api.service'
import ErrorFilter from '@/common/error.filter'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import Vuelidate from 'vuelidate'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false
Vue.filter('error', ErrorFilter)
Vue.use(Vuelidate)
ApiService.init()

import Tooltip from 'vue-directive-tooltip'
import 'vue-directive-tooltip/css/index.css'
Vue.use(Tooltip, {
	delay: 0,
	class: 'atlas-tooltip'
})

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

router.beforeEach(
	(to, from, next) => {
		return Promise
		.all([store.dispatch(CHECK_AUTH)])
		.then(() => {
			if (to.matched.some(r => r.meta.isAuthenticated)) {
				if (!store.getters.isAuthenticated) {
					location.href = process.env.CAS_URL + "/login?locale=ru&service=" + process.env.SERVICE_URL + to.fullPath
					next(false)
				}
				else {
					var roles = to.matched.filter(r => r.meta.access).map(record => record.meta.access )
					if (roles.length > 0) {
						if (store.getters.hasRoles(roles)) {
							next()
						}
						else {
							router.replace({ name: '403' })
						}
					}
					else {
						next()
					}
				}
			}
			else {
				next()
			}
		})
	}
)

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js